export default __webpack_public_path__ + "static/media/ic_pin.9207ed1a.svg";